import React, { useState } from "react";
import clinicService from "../../../../../services/clinic.service";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

function AddCustomization({ customValue, updateCustomization }) {
  const [showButton, setShowButton] = useState(false);
  const [cVal, updateCVal] = useState(customValue);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();
  const { clinicId } = useParams();
  const handleToogle = () => {
    setShowButton(!showButton);
  };
  const onSubmit = (data) => {
    console.log(data);
    const newData = [data];
    clinicService
      .updateCustomization(clinicId, newData)
      .then((res) => {
        //console.log(res.data)
        updateCustomization(res.data);
        toast.success("Added", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        reset();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      {showButton ? (
        <div className="d-flex justify-content-center mt-3">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-3">
              <label htmlFor="" className="form-label">
                {" "}
                Key
              </label>
              <input
                type="text"
                className="form-control me-3"
                placeholder="Key"
                {...register("optionKey", { required: true })}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="" className="form-label">
                Value
              </label>
              <input
                type="text"
                className="form-control me-3"
                placeholder="Value"
                {...register("optionValue", { required: true })}
              />
            </div>
            <div className="d-flex justify-content-between">
              <button type="submit" className="btn btn-secondary btn-sm">
                Add
              </button>

              <button
                className="btn btn-primary btn-sm"
                onClick={() => handleToogle()}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      ) : (
        <button
          className="btn btn-primary btn-sm mt-3 ms-2"
          onClick={() => handleToogle()}
        >
          <i className="bi bi-plus-circle"></i> Add New
        </button>
      )}
    </>
  );
}

export default AddCustomization;
